import {
	AUTOMATIC_ACCOUNT_ID,
	AUTOMATIC_ID,
} from '@atlassian/jira-issue-field-assignee-editview-full/src/utils/constants';
import { FieldValueLookupError } from '../../../common/errors';
import type { AssigneePublicSetValue } from '../../../common/fields/assignee';
import { singleValueLookup } from '../../../common/utils/single-value-lookup';

type AssigneeInternalValue = {
	id: string;
	accountId: string;
	accountStatus: string;
	name: string;
	picture: string;
};

type LookupAutomaticUser = {
	accountId: string;
	name: string;
	picture: string;
};

type LookupRegularUser = {
	id: string;
	accountStatus: string;
	accountId: string;
	name: string;
	picture: string;
};

export type LookupUser = LookupAutomaticUser | LookupRegularUser;

export const transformAssigneeSetValue = (
	value: AssigneePublicSetValue | null,
	lookupValues?: LookupUser[],
): AssigneeInternalValue | null => {
	if (value === null) {
		return null;
	}

	const foundValue = singleValueLookup<LookupRegularUser>(value, lookupValues, 'accountId');

	if (!foundValue) {
		throw new FieldValueLookupError();
	}

	if (foundValue.accountId === AUTOMATIC_ACCOUNT_ID) {
		return {
			...foundValue,
			id: AUTOMATIC_ID,
			accountStatus: 'active',
		};
	}

	return foundValue;
};
